import { DateTimeFormat } from './commonFunction';

const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
}[c]));

const displayOnly = (format) => (data, type, row) => (type === 'display' ? format(data, row) : data);

export const nameCell = displayOnly((data) => `<span class="catalog-name-cell">${escapeHtml(data)}</span>`);

export const versionCell = displayOnly((data) => (data == null || data === '' ? '' : `<span class="catalog-pill">${escapeHtml(data)}</span>`));

export const codeCell = displayOnly((data) => (data ? `<span class="catalog-chip">${escapeHtml(data)}</span>` : ''));

export const softCell = displayOnly((data) => (data ? `<span class="catalog-soft">${escapeHtml(data)}</span>` : ''));

export const durationCell = displayOnly((data) => (data == null || data === '' ? '<span class="text-muted">—</span>' : escapeHtml(data)));

export const auditSummary = (record) => {
    if (!record) return [];
    const stamp = (at, by) => [DateTimeFormat(at), by ? `by ${by}` : ''].filter(Boolean).join(' ');
    const items = [];
    if (record.created_at || record.created_by) items.push(`Created ${stamp(record.created_at, record.created_by)}`);
    if (record.updated_at || record.updated_by) items.push(`Updated ${stamp(record.updated_at, record.updated_by)}`);
    return items;
};

export const statusCell = displayOnly((data) => (data ? `<span class="catalog-status ${data === 'Active' ? 'is-active' : 'is-inactive'}">${escapeHtml(data)}</span>` : ''));

export const productLinkCell = (product, route, fallbackName) => {
    if (!product) return escapeHtml(fallbackName || '—');
    return `<a class="catalog-product-link" href="${escapeHtml(route)}" data-route="${escapeHtml(route)}">${escapeHtml(product.name)}<i class="fa fa-arrow-right"></i></a> <span class="catalog-pill" title="Version">${escapeHtml(product.version)}</span>`;
};
